import { render, staticRenderFns } from "./OfficialLeagueSlider.vue?vue&type=template&id=4b347044&"
import script from "./OfficialLeagueSlider.vue?vue&type=script&lang=js&"
export * from "./OfficialLeagueSlider.vue?vue&type=script&lang=js&"
import style0 from "./OfficialLeagueSlider.vue?vue&type=style&index=0&id=4b347044&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports